import type { BossConfig } from '../../entities/BossConfig';

export const HONEY_BADGER_CONFIG: BossConfig = {
  id: 'honey_badger',
  displayName: 'Медоед',
  bossType: 'charging',

  // Эффективно ~120 + 66% = ~200 урона за бой с воскрешением. Не толще Медведя (250).
  maxHp: 120,
  speed: 0,
  movementBehavior: 'charging_boss',

  chargingParams: {
    idleMs: 1400,
    windupMs: 500,
    chargeSpeed: 460,
    recoveryMs: 900,
    contactDamage: 0,
  },

  contactBehavior: 'instakill',
  instakillDragMs: 400,

  // Run-spritesheet 4 кадра играет только на charge. В покое (idle/windup/
  // recovery) — стоп-кадр, как у лося. Низ-по-центру origin для естественной
  // постановки лап на "земле".
  animateOnlyOnCharge: true,
  spriteOrigin: [0.5, 1],

  reviveOnce: {
    reviveAtHp: 0.66,
    fakeDeathText: 'ПОБЕДА!',
    reviveText: '...МЕДОЕД ЖИВ!',
    postReviveSpeedMul: 1.2,
    postReviveSizeMul: 0.85,
  },

  // Уменьшено в 4 раза: 80→20. Спрайт display height = 20 × 2 × scale = 40 px
  // на 720p, width ≈ 120 px (aspect 512/171 ≈ 2.99). Хитбокс 20×20. Лужа
  // смерти ~40 px (через recordEnemyPuddle с config.size).
  size: 20,
  // baseColor для Rectangle-плейсхолдера и tween-default'ов. Виден только если
  // overlay-спрайт не загрузится (страховка). phaseTints не задан — спрайт
  // остаётся в натуральных цветах PNG на всех фазах (медоед уязвим всегда,
  // визуально различать фазы не нужно, тинтить нет смысла).
  color: 0x3a3a3a,

  scoreReward: 1000,
};
